import { Link } from 'react-router';

export function DrawerFooter() {
  return (
    <footer className="bg-primary-dark">
      <div className="flex flex-col gap-2">
        <div className="flex flex-wrap items-center gap-2">
          <Link
            to="/terms-of-service"
            className="text-caption text-primary-foreground underline"
            target="_blank"
            rel="noreferrer"
          >
            Terms of Service
          </Link>
          <span className="text-caption">|</span>
          <Link
            to="/privacy-policy"
            className="text-caption text-primary-foreground underline"
            target="_blank"
            rel="noreferrer"
          >
            Privacy Policy
          </Link>
          <span className="text-caption">|</span>
          <a
            href="https://fighterspassport.com/contact/"
            className="text-caption text-primary-foreground underline"
            target="_blank"
            rel="noreferrer"
          >
            Contact Us
          </a>
          <span className="text-caption">|</span>
          <Link
            to="/request-demo"
            className="text-caption text-primary-foreground underline"
            target="_blank"
            rel="noreferrer"
          >
            Request Demo
          </Link>
        </div>
        <p className="text-caption font-light text-primary-foreground">
          Copyright © {new Date().getFullYear()} Fighters Passport.
        </p>
        <p className="text-caption font-light text-primary-foreground">All rights reserved.</p>
      </div>
    </footer>
  );
}
